export class Country {
  id: number;
  countryName: string;
  countryCode: string;
  phoneCode: string;
  continent: string;
  created_at: string;
  updated_at: string;
  deleted_at: string;
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/utils/objects/country.ts